module.exports = __webpack_public_path__ + "static/media/znajdzosobe.7fe50ee9.svg";